import styled from 'styled-components';

export const BlockedAppLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: auto;
  padding: 16px;
`;
